<!-- AgentRenewLicenseCheckPayment -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
                col-12
                d-none d-lg-flex
                justify-content-between
                align-items-center
              ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
              col-left-menu
              d-flex d-lg-none
              border-bottom
              align-items-center
              border-bottom
              w-100
              ps-3
              pe-3
            " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="3" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <div class="container py-4 font-family-bla">
                    <!-- จำนวนเงิน -->
                    <h4 class="text-center fw-bold mb-4">จำนวน {{ formatBaht(amount) }} บาท</h4>

                    <div class="row g-4 align-items-center">
                        <!-- กล่องวิธีชำระ -->
                        <div class="col-12 col-lg-8 payment-box">
                            <div class="d-flex align-items-center p-3 border rounded">
                                <img :src="qrImage" alt="Thai QR Payment" class="me-3" style="width:48px;height:48px;">
                                <div>
                                    <h6 class="fw-bold mb-1">Thai QR Payment ผ่าน Mobile Banking</h6>
                                    <p class="text-muted mb-0">สแกนภาพ QR Code ที่จะได้รับหลังจากกดปุ่ม "ชำระเงิน"
                                        และชำระเงินผ่าน Mobile Banking</p>
                                </div>
                            </div>
                        </div>

                        <!-- ปุ่มชำระเงิน -->
                        <div class="col-12 col-lg-4 text-lg-end">
                            <button class="btn btn-bla btn-pay" @click="handlePayment">
                                ชำระเงิน
                            </button>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>


    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark, faFileLines } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import '@/styles/payment-qr-popup.css'
import { openPaymentQrPopup } from '@/utils/payment-qr-popup'

import StepBar from "./StepBar.vue";

// import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: 'AgentRenewLicenseCheckPayment',
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            faFileLines: faFileLines,
            Loading: true,
            amount: "0.00",
            // ใช้โลโก้ placeholder (ใส่ path ของคุณเองได้)
            qrImage: new URL('@/assets/images/thaiqr.png', import.meta.url).href,
        }
    },
    computed: {
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();
    },
    methods: {
        async BindingData() {
            await this.GetDataTrainingCourseRenewal();

            this.amount = this.$store.state.AgentRenewLicense.DataTrainingCourseRenewal.amount;
        },
        async GetDataTrainingCourseRenewal() {
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            try {
                const response = await http.get(`AgencyERequest/GetDataTrainingCourseRenewal`, {
                    headers: { Authorization: `Bearer ${AuthorizeToken}` }
                });

                if (response.status === 200) {
                    this.$store.state.AgentRenewLicense.DataTrainingCourseRenewal = response.data;
                } else {
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">${error.response?.data?.ErrorMessage || 'เกิดข้อผิดพลาด'}</label>`,
                });
            }
        },
        formatBaht(n) {
            return Number(n).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        async handlePayment() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }
            
            await openPaymentQrPopup();
        },
        async Authentication(SUBJOB) {
            try {
                const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const request = {
                    AGENTCODE: [],
                    SUBJOB: SUBJOB
                };

                const res = await http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });

                if (res.data === '001' || res.data === '002') {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
                    }).then(() => {
                        this.$router.replace('/AgenteService');
                    });
                    return false; // มีเอกสารอยู่แล้ว
                }

                console.log('ยังไม่มีเอกสารที่สร้างไปก่อนหน้า');
                return true; // สามารถดำเนินการต่อได้

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
                }).then(() => {
                    this.$router.replace("/AgenteService");
                });
                return false; // ไม่สามารถดำเนินการต่อได้
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    }
}
</script>


<style scoped>
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

.payment-box .border {
    border: 1px solid #ddd !important;
    /* ขอบจางลง */
    max-width: 600px;
    /* ลดความกว้าง */
    margin: auto;
    /* จัดให้อยู่กลาง */
    background-color: #fff;
}

/* กล่องวิธีชำระ */
.pay-card {
    border: 2px solid #A2B9E2;
    border-radius: 12px;
    padding: 16px;
    background: #fff;
}

.qr-logo {
    width: 44px;
    height: 44px;
    border-radius: 8px;
}

/* ปุ่มชำระเงิน */
.btn-pay {
    width: 100%;
    min-height: 56px;
    border-radius: 10px;
    font-size: 1.1rem;
    padding-inline: 2rem;
}

@media (min-width: 992px) {
    .btn-pay {
        width: 220px;
    }
}

/* Swal QR mock */
.swal-wide {
    max-width: 520px !important;
}

.qr-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qr-img {
    width: 240px;
    height: 240px;
    border-radius: 12px;
    background:
        linear-gradient(45deg, #eee 25%, transparent 25%) -10px 0/20px 20px,
        linear-gradient(-45deg, #eee 25%, transparent 25%) -10px 0/20px 20px,
        linear-gradient(45deg, transparent 75%, #eee 75%) -10px 0/20px 20px,
        linear-gradient(-45deg, transparent 75%, #eee 75%) -10px 0/20px 20px,
        #000;
    /* กล่องดำลายสลับ ใช้แทนรูป QR จริง */
}
</style>